import React, { useRef, useState, useEffect } from 'react';
import Modal from 'react-bootstrap/Modal';
import moment from 'moment';
import axios from 'axios';

import { cmes } from '../../util/varios';
/* import CatalogoPersona from '../../catalogos/catalogoPersona';
import CatalogoAgente from '../../catalogos/catalogoAgente'; */
import { Mensaje, MensajeSiNo } from '../mensajes2';
import { Dimmer } from '../spinner';

import { formatMoneda,validaMonto,formatoMonto
} from '../../util/varios';


const AgregarUnidadContable = (props) => {

    const [clase, setClase] = useState('d-flex bluex-bg');
    const btnCancela = useRef();
    const btnAcepta = useRef();
    const txtAnio = useRef();
    const txtFechaApli = useRef();
    const cmbMes = useRef();
    const txtValor = useRef();
    const [idconsejo, setIdConsejo] = useState(0)
    const [mensaje, setMensaje] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mensajesino, setMensajesino] = useState({ mostrar: false, titulo: '', texto: '', icono: '' });
    const [mes,setMes] = useState(1)
    const [activate, setActivate] = useState(false);
    const [values,setValues] = useState()


    const [url, setUrl] = useState('');

    let op = require('../../../src/modulos/datos');
    let token = localStorage.getItem('jwtToken');


    const [operacion, setOperacion] = useState(0);


    useEffect(() => {
        let obj = JSON.parse(localStorage.getItem('post'));



    }, [props.operacion]);


    const blanquear = () => {

        
    }


    const cancelar = () => {

        blanquear();

        props.onHideCancela();
    }

    const onChange = (e) => {

        if(e.target.id === 'cmbMes'){
            setMes(parseInt(e.target.value))
        }

    }

    const handleInputMontoChange = (event) => {
        //setActiveIndex(1);
        validaMonto(event);
        if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
            event.target.value = '0,00'
        }
        if (event.which === 13 || typeof (event.which) === 'undefined') {

            /* if (event.target.value === '' || parseFloat(event.target.value.trim().replace(/\./g, "").replace(",", ".")) === 0.00) {
                event.target.value = '0,00'
            } */
            event.target.value = (formatoMonto(event.target.value));
           
          

        } else if (event.which === 46) {
            return false;
        } else if (event.which >= 48 && event.which <= 57) {
            return true;
        } else if (event.which === 8 || event.which === 0 || event.which === 44) {
            return true;
        } else return false;//alert(e.which);
    };

    const procesarRegistro = () => {

        let espiritu = JSON.parse(localStorage.getItem('espiritu'));
        let tipo;
        if (espiritu === 0) {
            tipo = 2;
        } else if (espiritu === 2) {
            tipo = 1;
        } else if (espiritu === 12) {
            tipo = 2;
        } else {
            tipo = 0;
        }

        let endpoint = `${op.conexion}/api/configuracion/actualizarunidad`;
      
         let body = {
            operacion:operacion,
            tipo:tipo,
            ani:txtAnio.current.value,
            me:cmbMes.current.value,
            val:txtValor.current.value.replace(/\./g, "").replace(",", "."),
            fech:txtFechaApli.current.value
        }

        axios.post(endpoint, body, {
           headers: {
          "x-access-token": `${token}`,
          'Content-Type': 'application/json'

        },
        }).then(function (response) {

            if (response.status === 200) {



                setActivate(false);



                setMensaje({ mostrar: true, titulo: 'Exito.', texto: 'Operacion Realizada.', icono: 'exito' });

            }

        }).catch(function (error) {

            setMensaje({ mostrar: true, titulo: 'Error', texto: error.response.data.message, icono: 'error' });
            setActivate(false);

        })

    }


    const onChangeValidar = (e) => {
        e.preventDefault();

        let sigue = true;

         if (txtAnio.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar un Año.', icono: 'informacion' });
            sigue = false;
            txtAnio.current.focus();

        } else if (cmbMes.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Seleccionar un mes.', icono: 'informacion' });
            sigue = false;
            cmbMes.current.focus();

        }  else if (txtFechaApli.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar la fecha e aplicación', icono: 'informacion' });
            sigue = false;
            txtFechaApli.current.focus();

        }  else if (txtValor.current.value === '') {
            setMensaje({ mostrar: true, titulo: 'Notificación', texto: 'Debe de Ingresar el Valor', icono: 'informacion' });
            sigue = false;
            txtValor.current.focus();

        } 

       
        if (sigue) {


            if (operacion === 3) {

                setMensajesino({ mostrar: true, titulo: 'Notificación', texto: 'Esta Seguro de eliminar Este Registro?', icono: 'informacion' })

            } else {
                procesarRegistro()

            }
        }


    };



    const handleCloseSi = () => {
        setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' });
        procesarRegistro()


    };

    const cerrarModal = () => {

        setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' });
        props.onHideCancela();
        props.renderizar();
    }



    return (
        <Modal
            {...props}
            size="md"
            aria-labelledby="contained-modal-title-vcenter"
            centered
            style={{ backgroundColor: "rgb(0,0,0,0.5)" }}
            backdrop="static"
            keyboard={false}
            onShow={() => {
                setOperacion(props.operacion);
             
                if (props.operacion !== 1) {

                    console.log(props.unidad)
                    setMes(props.unidad ? props.unidad.mes : props.unidad.mes)
                    setValues(props.unidad)
                

                } else {
                    setMes(1)
                    txtAnio.current.value = JSON.parse(localStorage.getItem('anioactu'));
                    txtFechaApli.current.value = moment.utc(JSON.parse(localStorage.getItem('fechasistema'))).format('YYYY-MM-DD')
                }

            }}
        >
            <Modal.Header className='azulGradiant'>
                <div className='fw-bold text-light'><h3>{operacion === 1 ? 'Agregar Unidad Contable' : operacion === 2 ? 'Modificar Unidad Contable' : operacion === 3 ? 'Eliminar Unidad Contable' : 'Consultar Unidad Contable'}</h3></div>
                <button className="bg-transparent" style={{ border: 0, margin: 0, padding: 0, color: "#ffffff" }} onClick={cancelar}>
                    <i className="far fa-window-close"></i>
                </button>

            </Modal.Header>
            <Modal.Body style={{ maxHeight: '70vh', overflow: 'scroll' }}>

                <Mensaje mensaje={mensaje}
                    onHide={() => {
                        mensaje.titulo === 'Exito.' ?
                            cerrarModal() :
                            setMensaje({ mostrar: false, titulo: '', texto: '', icono: '' })
                    }
                    } />
                <MensajeSiNo mensaje={mensajesino}
                    onHideNo={() => setMensajesino({ mostrar: false, titulo: '', texto: '', icono: '' })} onHideSi={handleCloseSi} />
              <Dimmer active={activate} inverted>
       
      </Dimmer>
                <div className='row col-md-12 px-0 mx-auto'>
                    <div className="input-group mb-2 input-group-sm col-sm-4 mx-auto ">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Año:</label>
                        <input type="text" ref={txtAnio} defaultValue={props.unidad ? props.unidad.anio : ''} disabled={operacion === 3 || operacion === 4 ? true : false} className="form-control text-right" autoComplete='off' maxLength={4} placeholder='AAAA' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id='inputRazonSoc' />
                    </div>
                    <div className='col-md-1'></div>
                    <div className="input-group mb-2 input-group-sm col-sm-7 ">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Fecha Aplicación:</label>
                        <input type="date" ref={txtFechaApli} disabled={operacion === 3 || operacion === 4 ? true : false} className="form-control text-uppercase" defaultValue={props.unidad ? moment.utc(props.unidad.fechaaplic).format('YYYY-MM-DD') : ''} autoComplete='off' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id='inputRazonSoc' />
                    </div>
                    <div className="input-group  mb-2 input-group-sm col-sm-6">
                        <label className="input-group-text" id="inputGroup-sizing-sm">Mes:</label>

                        <select className="form-select col-md-4" ref={cmbMes} disabled={operacion === 3 || operacion === 4 ? true : false} defaultValue={props.unidad ? parseInt(props.unidad.mes) : ''} onChange={onChange} aria-label="Default select example" id="cmbMes" >
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                            <option value="5">5</option>
                            <option value="6">6</option>
                            <option value="7">7</option>
                            <option value="8">8</option>
                            <option value="9">9</option>
                            <option value="10">10</option>
                            <option value="11">11</option>
                            <option value="12">12</option>


                        </select>
                        <input type="text" className="form-control fw-bold" disabled autoComplete='off' aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" value={cmes(operacion !== 1 && props.unidad ? parseInt(props.unidad.mes) : mes)} id='inputRazonSoc' />

                    </div>
                    <div className="input-group mb-2 input-group-sm col-sm-6">
                        <label className="input-group-text " id="inputGroup-sizing-sm">Valor:</label>
                        <input type="text"  disabled={operacion === 3 || operacion === 4 ? true : false} ref={txtValor} defaultValue={props.unidad ? formatMoneda(props.unidad.valor.toString().replace('.', ','), ',', '.', 2) : ''} className="form-control text-right" autoComplete='off'aria-label="Sizing example input" aria-describedby="inputGroup-sizing-sm" id='inputRazonSoc' onChange={handleInputMontoChange}/>
                    </div>
                   

                </div>




            </Modal.Body>
            <Modal.Footer>
                <div className='col-sm-12 d-flex justify-content-center row mx-auto py-1'>
                    <button type="button" ref={btnAcepta} onClick={onChangeValidar} className="col-sm-6 btn-sm btn btn-success rounded-pill"><i className="far fa-check-circle"></i>Aceptar</button>
                    <button type="button" ref={btnCancela} onClick={cancelar} className="col-sm-6 btn-sm btn btn-danger rounded-pill"><i className="fas fa-window-close"></i>Cancelar</button>
                </div>

            </Modal.Footer>
        </Modal>
    );
}
export default AgregarUnidadContable;